export default "__VITE_ASSET__YBuY0jdy__"